import { useEffect, useState, useCallback } from "react";
import { Search, DownloadCloud } from "lucide-react";
import { DashboardLayout } from "../../components/DashboardLayout";
import { EmptyState } from "../../components/Common";
import { ADMIN_MENU } from "../../lib/menus";
import { formatDate, typeLabel } from "../../lib/format";
import api from "../../lib/api";

export default function AdminDownloads() {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");

  const load = useCallback(() => {
    setRows(null);
    api.get(`/admin/downloads${q ? `?q=${encodeURIComponent(q)}` : ""}`).then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [q]);

  useEffect(() => { document.title = "Riwayat Download - DS KODE"; const t = setTimeout(load, 300); return () => clearTimeout(t); }, [load]);

  return (
    <DashboardLayout title="Riwayat Download" menu={ADMIN_MENU} testid="admin-downloads">
      <div className="relative mb-5 max-w-md"><Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" /><input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari member atau produk..." className="input pl-9" data-testid="download-search" /></div>
      {rows === null ? <div className="h-64 skeleton rounded-xl" /> : rows.length === 0 ? <EmptyState icon={DownloadCloud} title="Belum ada riwayat download." /> : (
        <div className="card overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[800px]">
              <thead className="bg-slate-50 border-b border-slate-200"><tr><th className="th">Member</th><th className="th">Produk</th><th className="th">Jenis File</th><th className="th">Tanggal</th><th className="th">IP</th><th className="th">User Agent</th></tr></thead>
              <tbody className="divide-y divide-slate-100">
                {rows.map((r) => (
                  <tr key={r.id} data-testid={`admin-dl-${r.id}`}>
                    <td className="td font-medium text-slate-900">{r.user_name}</td>
                    <td className="td">{r.product_title}</td>
                    <td className="td">{typeLabel(r.download_type)}</td>
                    <td className="td text-slate-500">{formatDate(r.downloaded_at)}</td>
                    <td className="td text-slate-500 font-mono text-xs">{r.ip_address || "-"}</td>
                    <td className="td text-slate-400 text-xs max-w-[200px] truncate">{r.user_agent || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </DashboardLayout>
  );
}
